module.exports = __webpack_public_path__ + "static/media/iStock-1167039323.97eba22c.jpg";